import { cn } from '@/app/utils/cn'

import {
  SUPPORT_LIST_TABS,
  SUPPORT_LIST_TAB_LABEL,
  SupportListTab,
} from '../SupportRequestQueue/useSupportQueue'
import { useSupportListCounts } from './useSupportListCounts'

interface SupportListTabsProps {
  value: SupportListTab
  onChange: (tab: SupportListTab) => void
  className?: string
}

export const SupportListTabs = ({
  value,
  onChange,
  className,
}: SupportListTabsProps) => {
  const counts = useSupportListCounts()

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {SUPPORT_LIST_TABS.map((tab) => {
        const isActive = tab === value
        const count = counts[tab]

        return (
          <button
            key={tab}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(tab)}
            className={cn(
              'flex h-9 items-center gap-2 rounded-full border px-4 text-sm font-semibold transition-colors',
              isActive
                ? 'border-primary bg-primary text-white'
                : 'border-gray01 bg-white text-black04 hover:bg-gray02',
            )}
          >
            {SUPPORT_LIST_TAB_LABEL[tab]}

            {!!count && (
              <span
                className={cn(
                  'flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[11px]',
                  isActive ? 'bg-white text-primary' : 'bg-gray02 text-black04',
                )}
              >
                {count > 99 ? '+99' : count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
